import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import styles from './FooterBottomLinks.module.scss';

export interface FooterBottomLinksProps {
	links: {
		url: string;
		name?: string;
		target?: string;
	}[];
}

export const UI_FooterBottomLinks = ({ links }: FooterBottomLinksProps) => {
	if (!links || links.length === 0) return null;

	return (
		<div className={styles.FooterBottomLinks}>
			<div className={styles.FooterBottomLinks_divider}></div>
			<div className={styles.FooterBottomLinks_wrapper}>
				<ul className={styles.FooterBottomLinks_list}>
					{links.map((link, index) => (
						<li key={index} className={styles.FooterBottomLinks_item}>
							<UI_Link url={link.url} target={link.target} withUnderline className={styles.FooterBottomLinks_link}>
								{link.name}
							</UI_Link>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};
